export type SoleraAccountCreationStep =
  | 'ConfirmAccountInfo'
  | 'EmailVerification'
  | 'CreatePassword'
  | 'ReadyToStart'
  | 'Error';

export type SoleraAccountCreationState = {
  step: SoleraAccountCreationStep;
  token?: string;
};

export const initialState: SoleraAccountCreationState = {
  step: 'ConfirmAccountInfo',
};

export type SoleraAccountCreationAction =
  | { type: 'SET_STEP'; step: SoleraAccountCreationStep }
  | { type: 'SET_TOKEN'; token: string };

export const reducer = (
  state: SoleraAccountCreationState,
  action: SoleraAccountCreationAction,
): SoleraAccountCreationState => {
  switch (action.type) {
  case 'SET_STEP':
    return {
      ...state,
      step: action.step,
    };
  case 'SET_TOKEN':
    return {
      ...state,
      token: action.token,
    };
  default:
    return state;
  }
};
